import React from 'react';
import { JsonForms } from '@jsonforms/react';
import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputLabel, TextField, Box } from '@mui/material';

// Кастомный рендерер для текстового поля
const CustomTextRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  // Обработчик изменения значения
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    // Добавляем префикс "Hello, " к значению
    handleChange(path, newValue ? `Hello, ${newValue}` : '');
  };

  // Если элемент невидим, не рендерим ничего
  if (!visible) {
    return null;
  }

  //console.log(data)

  let sx={ 
        color: 'rgb(0,83,146)', 
        marginTop: 0, 
        marginBottom: 1, 
        border: 1, 
        borderRadius: 1, 
        //height: "85%", 
        paddingTop: "14px", 
        paddingBottom: "14px", 
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14, 
        fontWeight: 600,
        minWidth: 160,
      }

  if (uischema.options.minWidth !== undefined) {
    sx['minWidth'] = uischema.options.minWidth
  }

  return (
    <Box sx={sx}>
      <p style={{margin: "2px"}}>{data}</p>
      {/*<Box sx={{ color: 'gray', marginTop: 1 }}>
        Preview: {data || 'No value entered'}
      </Box>*/}
    </Box>
  );
};

// Оборачиваем рендерер с помощью withJsonFormsControlProps
const CustomTextControl = withJsonFormsControlProps(CustomTextRenderer);

export default CustomTextControl